module.exports = __webpack_public_path__ + "img/dr_reena_photo.9e2d38a1.png";